import React, { Dispatch, useCallback, useMemo, SetStateAction } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';

import { ImageRelativeBrand } from '../../utils/LogoForBrands'
import SendGTAGEvent from '../../utils/sendGTAGEvent';

import * as S from './styles'
import Title from '../../components/Title'

interface IBrandsUser {
    env: string;
    search: string;
}

interface IFilterBrandsProps {
    filterName: string;
    filterItems: {
        filterItemName: string;
        filterItemValue: string;
    }[];
    isOpen: boolean;
    setfilterProperties: Dispatch<SetStateAction<IBrandsUser>>;
    className: string;
}

const Home: React.FC<IFilterBrandsProps> = ({
    filterName,
    setfilterProperties,
    filterItems,
    isOpen,
    className,
}) => {

    const location = useLocation()
    const navigate = useNavigate()

    const shouldReload = useMemo(() => {
        const pagesShouldReload = ['/my-wishlists']
        return !pagesShouldReload.find(link => location.pathname.includes(link))
    }, [location.pathname])

    const onChangeFilterProperties = useCallback((filterItemValue: any) => {
        setfilterProperties((prevState: any) => ({ ...prevState, [filterName]: filterItemValue }))
        if (!shouldReload && !location.pathname.includes(filterItemValue)) navigate('/my-wishlists')

        window.location.reload();
    }, [filterName, location.pathname, navigate, setfilterProperties, shouldReload])

    const selectedEnv = useMemo(() => {

        return filterItems?.map(env => {
            return (
                <button
                    key={env.filterItemName}
                    onClick={() => {
                        onChangeFilterProperties(env.filterItemValue)
                        SendGTAGEvent(
                            'seleciona_marca',
                            'Marca',
                            'Selecionou uma marca',
                            env.filterItemName
                        )
                    }}>

                    <img src={ImageRelativeBrand(env.filterItemValue).Image} alt='logo' />
                    <span>{env.filterItemName}</span>

                </button>
            )
        })
    }, [filterItems, onChangeFilterProperties])

    return (
        isOpen ?
            <S.Container className={className}>
                <Title className={'title'} />
                <label />
                <S.Content>
                    {selectedEnv}
                </S.Content>
            </S.Container>
            : null
    )
}


export default Home 